import type { AccessProfileId, CommandDeckSurfaceMode } from '../contracts/types'
import type { WorkContextRow } from '../lib/commandDeckWorkContext'
import type { CommandDeckStatusPillVariant } from './CommandDeckStatusPill'
import type { SpatialMapNodeStatus } from './spatialMapModel'

export type StatusPillDescriptor = {
  label: string
  variant: CommandDeckStatusPillVariant
}

export function spatialMapStatusToPillVariant(status: SpatialMapNodeStatus): CommandDeckStatusPillVariant {
  const map: Record<SpatialMapNodeStatus, CommandDeckStatusPillVariant> = {
    active: 'active',
    ready: 'ready',
    preview: 'preview',
    coming_soon: 'soon',
    locked: 'locked',
    boundary: 'locked',
  }
  return map[status]
}

export function workContextRowPill(
  row: WorkContextRow,
  mode: CommandDeckSurfaceMode
): StatusPillDescriptor | null {
  if (row.id === 'surface' && row.value !== 'Unresolved') {
    return { label: 'ACTIVE', variant: 'active' }
  }
  if (row.id === 'session') {
    if (mode === 'preview' || row.source === 'preview') {
      return { label: 'PREVIEW', variant: 'preview' }
    }
    return { label: 'CURRENT', variant: 'current' }
  }
  if (row.id === 'position' && /coherent|ready|framed|defined|grounded/i.test(row.value)) {
    return { label: 'READY', variant: 'ready' }
  }
  return null
}

export function workContextProfilePill(profileId: AccessProfileId): StatusPillDescriptor | null {
  if (profileId === 'creator_beta') {
    return { label: 'BETA', variant: 'beta' }
  }
  return null
}

export function continueAlignedPill(hasContinueLabel: boolean): StatusPillDescriptor | null {
  if (!hasContinueLabel) return null
  return { label: 'ALIGNED', variant: 'aligned' }
}

export function libraryPendingPill(): StatusPillDescriptor {
  return { label: 'PENDING', variant: 'pending' }
}

export function recallPlannedPill(): StatusPillDescriptor {
  return { label: 'PLANNED', variant: 'planned' }
}

export function deckPulseModePill(mode: CommandDeckSurfaceMode): StatusPillDescriptor {
  return mode === 'preview'
    ? { label: 'PREVIEW', variant: 'preview' }
    : { label: 'CURRENT', variant: 'current' }
}

export function synkPulseStatusPill(mode: CommandDeckSurfaceMode): StatusPillDescriptor {
  return mode === 'preview'
    ? { label: 'PREVIEW', variant: 'preview' }
    : { label: 'ACTIVE', variant: 'active' }
}
